import $ from 'jquery'
import 'gsap'

export default {
	namespace: 'home',
	beforeEnter() {

	},
	afterEnter(){

	},
	beforeLeave(){

	},
	afterLeave() {

	}
}
